import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { ThemeProvider } from 'emotion-theming'
import * as Sentry from '@sentry/react'
import '../scss/application.scss'

import ScreenerPage from '../app_screener/ScreenerPage'
import ErrorBoundaryFallback from '../components/ErrorBoundaryFallback'

const theme = {
  breakpoints: ['40em', '52em', '64em'],
  space: [0, 4, 8, 16, 32, 64, 128, 256],
}

const FrontEndScreener = () => {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorBoundaryFallback />} showDialog>
      <ThemeProvider theme={theme}>
        <BrowserRouter basename="/screeners">
          <Switch>
            <Route exact path="/:uuid/" component={ScreenerPage} />
          </Switch>
        </BrowserRouter>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  )
}

export default FrontEndScreener
